import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { AUTOMATION_QUERY_KEYS } from '../../queryKeys';

interface Params {
	templateId: string;
	includeAll: boolean;
	createAutomationRequest: Api.ICreateAutomationRequest;
	impersonationContext?: Api.IImpersonationContext;
}

export function useApproveAutomationContactsMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.IAutomationOnHold[], variables: Params) => void;
	onError?: (error: Api.IOperationResultNoValue, variables: Params) => void;
} = {}) {
	const userSession = useUserSession();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ templateId, includeAll, createAutomationRequest, impersonationContext }: Params) => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationOnHold[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `AutomationOnHold/${encodeURIComponent(templateId)}?includeAll=${includeAll}`,
					impersonationContext,
				}),
				'POST',
				createAutomationRequest
			);
		},
		onSuccess: (data, variables) => {
			queryClient.invalidateQueries({ queryKey: AUTOMATION_QUERY_KEYS.onHoldContacts(variables.templateId) });
			queryClient.invalidateQueries({ queryKey: AUTOMATION_QUERY_KEYS.onHoldSummary() });
			onSuccess?.(data, variables);
		},
		onError,
	});
}
